import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Modal, Divider, Button } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import '../../css/regimen.scss'
import { Redirect, useHistory, useLocation } from 'react-router'
import {
  assignRegimens,
  getAutoAssignedRegs,
} from '../../store/action/regimen.action'
import { assignDevices, assignPlan } from '../../store/action/device.action'
import Assigned from './assigned'
import Filter from './regimen.filter'
import List from './regimens.list'
import { setNewPatient } from '../../store/action/patient.action'

const PatientRegimens = (props) => {
  var location = useLocation()
  var history = useHistory()
  useEffect(() => {
    location.state?.assignedDevices &&
      props.assignDevices(location.state?.assignedDevices)
    location.state?.assignedPlan &&
      props.assignPlan(location.state?.assignedPlan)
    props.setNewPatient(location.state.patient)
    location.state?.regimens
      ? props.assignRegimens(location.state.regimens)
      : props.autoAssignRegimens({...location.state.patient,company:props.customer.company})
  }, [])
  console.log(location, 'PROPS+++++++++++++>', props)
  var showConfirmBox = () => {
    Modal.confirm({
      title: 'Are you sure you want to leave this page?',
      icon: <ExclamationCircleOutlined />,
      content: 'Your changes will be lost if you go back.',
      okText: 'Yes',
      cancelText: 'No',
      onOk: handleBack,
    })
  }

  var handleBack = () => {
    history.push({
      pathname:
        props.assignedDevices.length != 0
          ? '/patient/add/devices'
          : '/patient/add/careplan',
      state: {
        patient: props.newPatient,
        assignedPlan: props.assignedPlan,
        assignedDevices: props.assignedDevices,
      },
    })
  }

  var handleNext = () => {
    history.push({
      pathname: '/patient/add/schedule',
      state: {
        patient: props.newPatient,
        regimens: props.assignedRegs,
        assignedPlan: props.assignedPlan,
        assignedDevices: props.assignedDevices,
      },
    })
  }

  return (
    <>
      {!location.state?.patient?.age && <Redirect to='/patient/add/info' />}
      <Row align='middle' className='headerRow divide regHeaderCont'>
        <Col className='headerText regHeader'>ASSIGN REGIMENS</Col>
      </Row>
      <Row className='regContainer'>
        <Col flex={'auto'} className='formBody'>
          <Filter />
          <List />
        </Col>
        <Col flex={'350px'} className='assignCol'>
          <Assigned />
        </Col>
      </Row>
      <Divider style={{ marginTop: 0 }} />
      <Row gutter={10} justify='end'>
        <Col>
          <Button onClick={showConfirmBox} className={'nextBtn'}>
            BACK
          </Button>
        </Col>
        <Col>
          <Button id={'saveregimen'} onClick={handleNext} className={'nextBtn'}>
            NEXT
          </Button>
        </Col>
      </Row>
    </>
  )
}

PatientRegimens.propTypes = {
  company: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    newPatient: state.patient.newpatient,
    assignedRegs: state.regimen.assignedRegs,
    assignedDevices: state.device.assignedDevices,
    assignedPlan: state.device.assignedPlan,
    customer: state.profile.customer,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    autoAssignRegimens: (patient) => dispatch(getAutoAssignedRegs(patient)),
    setNewPatient: (patient) => dispatch(setNewPatient(patient)),
    assignRegimens: (regimens) => dispatch(assignRegimens({ regimens })),
    assignPlan: (plan) => dispatch(assignPlan(plan)),
    assignDevices: (devices) => dispatch(assignDevices(devices)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientRegimens)
